import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';
import { AttachService, AUTOCREATION_TICKET_CUSTOMER, AUTOCREATION_TICKET_CUSTOMER_VALUES, Conf, CrudService, MessageService, workaroundClickEventDatatable } from 'orv-ui-base-lib';

import { AttachmentUploadComponent } from '../attachments/attachment-upload/attachment-upload.component';

@Component({
	selector: 'app-confs',
	templateUrl: './confs.component.html',
	styleUrls: ['./confs.component.scss']
})
export class ConfsComponent implements OnInit {

	loading: boolean = false;
	rows: any[];
	settings: Conf[];

	keyword: string;

	confticketauto = AUTOCREATION_TICKET_CUSTOMER;
	confticketautovalues = AUTOCREATION_TICKET_CUSTOMER_VALUES;
	confticketautovaluesobj = {};

	@Input()
	set prefix(prefix: any) {
		this._prefix = prefix;
		this.loadSettings(prefix);
	}
	get prefix(): any {
		return this._prefix;
	}
	_prefix: any;

	constructor(private crudService: CrudService<Conf>,
		private attachService: AttachService,
		private messageService: MessageService,
		private modalService: NgbModal,
		private translateService: TranslateService) {
		Object.keys(AUTOCREATION_TICKET_CUSTOMER_VALUES).map(o => {
			this.confticketautovaluesobj[o] = AUTOCREATION_TICKET_CUSTOMER_VALUES[o];
		});
	}

	ngOnInit() {
	}

	loadSettings(prefix: any) {
		this.loading = true;
		this.crudService.getAll(Conf, 'conf').subscribe(confs => {
			if (!prefix) return true;
			this.settings = confs.filter(conf => {
				const value = prefix.value;
				const condition = prefix.condition;
				const index = conf.confkey.indexOf(value);
				return condition === 'eq' ? index === 0 :
					condition === 'ne' ? index !== 0 : true;
			});
			this.filterSettings();
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.setting'));
			this.loading = false;
		});
	}

	filterSettings() {
		this.rows = this.settings.filter(item => {
			return !this.keyword || (this.keyword && ((item.confkey && item.confkey.indexOf(this.keyword) >= 0) || (item.note && item.note.indexOf(this.keyword) >= 0)));
		}).map(item => ({ edit: false, conf: cloneDeep(item) }));
	}

	undo(row: any) {
		const index = this.settings.map(item => item.id).indexOf(row.conf.id);
		row.conf = cloneDeep(this.settings[index]);
		row.edit = false;
	}

	onConfticketautoChange(event: boolean, actual: any, value: number) {
		let actualvalues = actual.confval.split(',');
		if (event) {
			actualvalues.push(value);
			actualvalues = actualvalues.sort((a, b) => a - b);
		} else {
			actualvalues = actualvalues.filter(e => e !== '' + value);
		}
		actual.confval = actualvalues.join(',');
	}

	isConfticketautoChecked(actual: string, value: string) {
		const actualvalues = actual.split(',');
		return actualvalues.includes('' + value);
	}

	confirm(row: any) {
		const newConf = row.conf;
		this.crudService.saveEntity(Conf, 'conf', newConf).subscribe(conf => {
			const index = this.settings.map(item => item.id).indexOf(row.conf.id);
			this.settings[index] = conf;
			row.conf = cloneDeep(this.settings[index]);
			row.edit = false;
			const messages = this.translateService.instant(['labels.setting-save-success', 'labels.setting']);
			this.messageService.sendSuccess(messages['labels.setting-save-success'], messages['labels.setting']);
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.setting'));
		});
	}


	search() {
		this.filterSettings();
	}

	resetSearch() {
		this.keyword = null;
		this.search();
	}

	upload(row: Conf, event: any) {
		workaroundClickEventDatatable(event);

		const modal = this.modalService.open(AttachmentUploadComponent, { centered: true, size: 'lg' });
		modal.componentInstance.isImport = false;
		modal.componentInstance.entity = row.id.toString();
		modal.componentInstance.eid = row.id;
		modal.componentInstance.uploadfolder = 'conf';
		modal.componentInstance.accept = '.pdf';

		modal.result.then(() => {
			this.loadSettings(this.prefix);
			this.messageService.sendSuccess(this.translateService.instant('labels.upload-success'));
		}).catch(() => {});
	}
}
